import { makeStyles } from "@material-ui/core";

export const globalClasses = makeStyles(theme => ({
  AMIGBigButton: {
    width: 'clamp(1px, 100%, 300px)',
  },
}));